export const succesngonit = {
    data: {
        initialData: {
            maxContractDate: "2025-03-19",
            maxPercentageAdministration: 0.3,
            maxRentalFee: 5000000
        },
        locations: [
            {
                SuraCodigoDepartamento__c: "25",
                SuraCodigoCiudad__c: "11850",
                SURADepartamento__c: "Cundinamarca",
                SURACodigo__c: "2511850",
                SURACiudad__c: "Chinauta",
                SURACiudadDepartamento__c: "Chinauta - Cundinamarca",
                Id: "a7PD6000000DRL6MAO"
            },
            {
                SuraCodigoDepartamento__c: "17",
                SuraCodigoCiudad__c: "17174",
                SURADepartamento__c: "Caldas",
                SURACodigo__c: "1717174",
                SURACiudad__c: "Chinchina",
                SURACiudadDepartamento__c: "Chinchina - Caldas",
                Id: "a7PD6000000DRL7MAO"
            },
            {
                SuraCodigoDepartamento__c: "63",
                SuraCodigoCiudad__c: "63190",
                SURADepartamento__c: "Quindío",
                SURACodigo__c: "6363190",
                SURACiudad__c: "Circasia",
                SURACiudadDepartamento__c: "Circasia - Quindío",
                Id: "a7PD6000000DRL8MAO"
            },
            {
                SuraCodigoDepartamento__c: "13",
                SuraCodigoCiudad__c: "13222",
                SURADepartamento__c: "Bolívar",
                SURACodigo__c: "1313222",
                SURACiudad__c: "Clemencia",
                SURACiudadDepartamento__c: "Clemencia - Bolívar",
                Id: "a7PD6000000DRL9MAO"
            },
            {
                SuraCodigoDepartamento__c: "15",
                SuraCodigoCiudad__c: "15204",
                SURADepartamento__c: "Boyacá",
                SURACodigo__c: "1515204",
                SURACiudad__c: "Combita",
                SURACiudadDepartamento__c: "Combita - Boyacá",
                Id: "a7PD6000000DRLAMA4"
            },
            {
                SuraCodigoDepartamento__c: "05",
                SuraCodigoCiudad__c: "5212",
                SURADepartamento__c: "Antioquia",
                SURACodigo__c: "055212",
                SURACiudad__c: "Copacabana",
                SURACiudadDepartamento__c: "Copacabana - Antioquia",
                Id: "a7PD6000000DRLBMA4"
            },
            {
                SuraCodigoDepartamento__c: "63",
                SuraCodigoCiudad__c: "13212",
                SURADepartamento__c: "Quindío",
                SURACodigo__c: "6313212",
                SURACiudad__c: "Cordoba",
                SURACiudadDepartamento__c: "Cordoba - Quindío",
                Id: "a7PD6000000DRLCMA4"
            },
            {
                SuraCodigoDepartamento__c: "25",
                SuraCodigoCiudad__c: "25214",
                SURADepartamento__c: "Cundinamarca",
                SURACodigo__c: "2525214",
                SURACiudad__c: "Cota",
                SURACiudadDepartamento__c: "Cota - Cundinamarca",
                Id: "a7PD6000000DRLDMA4"
            },
            {
                SuraCodigoDepartamento__c: "54",
                SuraCodigoCiudad__c: "54001",
                SURADepartamento__c: "Norte De Santander",
                SURACodigo__c: "5454001",
                SURACiudad__c: "Cucuta",
                SURACiudadDepartamento__c: "Cucuta - Norte De Santander",
                Id: "a7PD6000000DRLEMA4"
            },
            {
                SuraCodigoDepartamento__c: "50",
                SuraCodigoCiudad__c: "50226",
                SURADepartamento__c: "Meta",
                SURACodigo__c: "5050226",
                SURACiudad__c: "Cumaral",
                SURACiudadDepartamento__c: "Cumaral - Meta",
                Id: "a7PD6000000DRLFMA4"
            },
            {
                SuraCodigoDepartamento__c: "66",
                SuraCodigoCiudad__c: "66170",
                SURADepartamento__c: "Risaralda",
                SURACodigo__c: "6666170",
                SURACiudad__c: "Dosquebradas",
                SURACiudadDepartamento__c: "Dosquebradas - Risaralda",
                Id: "a7PD6000000DRLGMA4"
            },
            {
                SuraCodigoDepartamento__c: "15",
                SuraCodigoCiudad__c: "15238",
                SURADepartamento__c: "Boyacá",
                SURACodigo__c: "1515238",
                SURACiudad__c: "Duitama",
                SURACiudadDepartamento__c: "Duitama - Boyacá",
                Id: "a7PD6000000DRLHMA4"
            },
            {
                SuraCodigoDepartamento__c: "05",
                SuraCodigoCiudad__c: "5148",
                SURADepartamento__c: "Antioquia",
                SURACodigo__c: "055148",
                SURACiudad__c: "El Carmen De Viboral",
                SURACiudadDepartamento__c: "El Carmen De Viboral - Antioquia",
                Id: "a7PD6000000DRLIMA4"
            },
            {
                SuraCodigoDepartamento__c: "54",
                SuraCodigoCiudad__c: "54261",
                SURADepartamento__c: "Norte De Santander",
                SURACodigo__c: "5454261",
                SURACiudad__c: "El Zulia",
                SURACiudadDepartamento__c: "El Zulia - Norte De Santander",
                Id: "a7PD6000000DRLJMA4"
            },
            {
                SuraCodigoDepartamento__c: "11",
                SuraCodigoCiudad__c: "11265",
                SURADepartamento__c: "Bogotá D.C.",
                SURACodigo__c: "1111265",
                SURACiudad__c: "Engativa",
                SURACiudadDepartamento__c: "Engativa - Bogotá D.C.",
                Id: "a7PD6000000DRLKMA4"
            },
            {
                SuraCodigoDepartamento__c: "05",
                SuraCodigoCiudad__c: "5266",
                SURADepartamento__c: "Antioquia",
                SURACodigo__c: "055266",
                SURACiudad__c: "Envigado",
                SURACiudadDepartamento__c: "Envigado - Antioquia",
                Id: "a7PD6000000DRLLMA4"
            },
            {
                SuraCodigoDepartamento__c: "73",
                SuraCodigoCiudad__c: "73268",
                SURADepartamento__c: "Tolima",
                SURACodigo__c: "7373268",
                SURACiudad__c: "Espinal",
                SURACiudadDepartamento__c: "Espinal - Tolima",
                Id: "a7PD6000000DRLMMA4"
            },
            {
                SuraCodigoDepartamento__c: "25",
                SuraCodigoCiudad__c: "25269",
                SURADepartamento__c: "Cundinamarca",
                SURACodigo__c: "2525269",
                SURACiudad__c: "Facatativa",
                SURACiudadDepartamento__c: "Facatativa - Cundinamarca",
                Id: "a7PD6000000DRLNMA4"
            },
            {
                SuraCodigoDepartamento__c: "63",
                SuraCodigoCiudad__c: "63272",
                SURADepartamento__c: "Quindío",
                SURACodigo__c: "6363272",
                SURACiudad__c: "Filandia",
                SURACiudadDepartamento__c: "Filandia - Quindío",
                Id: "a7PD6000000DRLOMA4"
            },
            {
                SuraCodigoDepartamento__c: "18",
                SuraCodigoCiudad__c: "18001",
                SURADepartamento__c: "Caquetá",
                SURACodigo__c: "1818001",
                SURACiudad__c: "Florencia",
                SURACiudadDepartamento__c: "Florencia - Caquetá",
                Id: "a7PD6000000DRLPMA4"
            },
            {
                SuraCodigoDepartamento__c: "68",
                SuraCodigoCiudad__c: "68276",
                SURADepartamento__c: "Santander",
                SURACodigo__c: "6868276",
                SURACiudad__c: "Floridablanca",
                SURACiudadDepartamento__c: "Floridablanca - Santander",
                Id: "a7PD6000000DRLQMA4"
            },
            {
                SuraCodigoDepartamento__c: "11",
                SuraCodigoCiudad__c: "11279",
                SURADepartamento__c: "Bogotá D.C.",
                SURACodigo__c: "1111279",
                SURACiudad__c: "Fontibon",
                SURACiudadDepartamento__c: "Fontibon - Bogotá D.C.",
                Id: "a7PD6000000DRLRMA4"
            },
            {
                SuraCodigoDepartamento__c: "25",
                SuraCodigoCiudad__c: "25286",
                SURADepartamento__c: "Cundinamarca",
                SURACodigo__c: "2525286",
                SURACiudad__c: "Funza",
                SURACiudadDepartamento__c: "Funza - Cundinamarca",
                Id: "a7PD6000000DRLSMA4"
            },
            {
                SuraCodigoDepartamento__c: "25",
                SuraCodigoCiudad__c: "25290",
                SURADepartamento__c: "Cundinamarca",
                SURACodigo__c: "2525290",
                SURACiudad__c: "Fusagasuga",
                SURACiudadDepartamento__c: "Fusagasuga - Cundinamarca",
                Id: "a7PD6000000DRLTMA4"
            },
            {
                SuraCodigoDepartamento__c: "08",
                SuraCodigoCiudad__c: "8296",
                SURADepartamento__c: "Atlántico",
                SURACodigo__c: "088296",
                SURACiudad__c: "Galapa",
                SURACiudadDepartamento__c: "Galapa - Atlántico",
                Id: "a7PD6000000DRLUMA4"
            },
            {
                SuraCodigoDepartamento__c: "63",
                SuraCodigoCiudad__c: "63302",
                SURADepartamento__c: "Quindío",
                SURACodigo__c: "6363302",
                SURACiudad__c: "Genova",
                SURACiudadDepartamento__c: "Genova - Quindío",
                Id: "a7PD6000000DRLVMA4"
            },
            {
                SuraCodigoDepartamento__c: "25",
                SuraCodigoCiudad__c: "25307",
                SURADepartamento__c: "Cundinamarca",
                SURACodigo__c: "2525307",
                SURACiudad__c: "Girardot",
                SURACiudadDepartamento__c: "Girardot - Cundinamarca",
                Id: "a7PD6000000DRLWMA4"
            },
            {
                SuraCodigoDepartamento__c: "05",
                SuraCodigoCiudad__c: "5308",
                SURADepartamento__c: "Antioquia",
                SURACodigo__c: "055308",
                SURACiudad__c: "Girardota",
                SURACiudadDepartamento__c: "Girardota - Antioquia",
                Id: "a7PD6000000DRLXMA4"
            },
            {
                SuraCodigoDepartamento__c: "68",
                SuraCodigoCiudad__c: "68307",
                SURADepartamento__c: "Santander",
                SURACodigo__c: "6868307",
                SURACiudad__c: "Giron",
                SURACiudadDepartamento__c: "Giron - Santander",
                Id: "a7PD6000000DRLYMA4"
            },
            {
                SuraCodigoDepartamento__c: "76",
                SuraCodigoCiudad__c: "76111",
                SURADepartamento__c: "Valle Del Cauca",
                SURACodigo__c: "7676111",
                SURACiudad__c: "Guadalajara De Buga",
                SURACiudadDepartamento__c: "Guadalajara De Buga - Valle Del Cauca",
                Id: "a7PD6000000DRLZMA4"
            },
            {
                SuraCodigoDepartamento__c: "50",
                SuraCodigoCiudad__c: "47318",
                SURADepartamento__c: "Meta",
                SURACodigo__c: "5047318",
                SURACiudad__c: "Guamal",
                SURACiudadDepartamento__c: "Guamal - Meta",
                Id: "a7PD6000000DRLaMAO"
            },
            {
                SuraCodigoDepartamento__c: "05",
                SuraCodigoCiudad__c: "5318",
                SURADepartamento__c: "Antioquia",
                SURACodigo__c: "055318",
                SURACiudad__c: "Guarne",
                SURACiudadDepartamento__c: "Guarne - Antioquia",
                Id: "a7PD6000000DRLbMAO"
            },
            {
                SuraCodigoDepartamento__c: "25",
                SuraCodigoCiudad__c: "25335",
                SURADepartamento__c: "Cundinamarca",
                SURACodigo__c: "2525335",
                SURACiudad__c: "Guayabetal",
                SURACiudadDepartamento__c: "Guayabetal - Cundinamarca",
                Id: "a7PD6000000DRLcMAO"
            },
        ]
    },
    error: false
}